const validate = (values) => {
    const errors = {};
    if (!values.programId) {
        errors.programId = 'Please select program';
    }
    if (!values.targetId) {
        errors.targetId = 'Please select target';
    }
    if(!values.graphTypeId) {
        errors.graphTypeId = 'Please select graph type';
    }
   
    return errors;
};
export default validate;




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionGraph/SkillAcuisitionGraph/validate.js